import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

// Create a styled container for the loading spinner
const LoadingContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '80vh',
  padding: theme.spacing(4),
  backgroundColor: theme.palette.background.default,
}));

// Styled typography for the loading text
const LoadingText = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(2),
  color: theme.palette.primary.main,
  fontWeight: 500,
}));

const LoadingSpinner = () => {
  return (
    <LoadingContainer>
      <CircularProgress 
        size={60} 
        thickness={4}
        sx={{ 
          color: 'primary.main',
          animationDuration: '1000ms'
        }} 
      />
      <LoadingText variant="h6" component="p">
        Ladataan...
      </LoadingText>
    </LoadingContainer>
  );
};

export default LoadingSpinner;